export const manage_recordings_api = {
  get_recordings: "host/zoom/recordings/unmapped/list",
  get_all_recordings: "host/zoom/recordings/all",
  save_recordings_sections: "host/zoom/recordings/map",
};
